import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Accelerator() {
  const rows = [{
    sit: 'Tu honorario',
    sin: 'El de la OS o menos',
    con: '30-50% sobre el mercado'
  }, {
    sit: 'Cobros',
    sin: 'Incómodos e irregulares',
    con: 'Sistema sin drama en 5 pasos'
  }, {
    sit: 'Captación',
    sin: 'Solo boca a boca',
    con: 'Boca a boca + Instagram + derivaciones'
  }, {
    sit: 'Imagen profesional',
    sin: 'Sin sistema visible',
    con: 'Identidad profesional coherente'
  }, {
    sit: 'Escala',
    sin: 'Solo sesiones individuales',
    con: 'Talleres, supervisión y diversificación'
  }];
  const modules = [{
    icon: '🔍',
    title: 'Módulo 1 — La Mentalidad de la Psicóloga de Élite',
    desc: 'Las 5 creencias que te cuestan dinero · Techo de cristal profesional · Identidad de especialista vs. generalista · La especialización como estrategia de precios · Autoevaluación de posicionamiento'
  }, {
    icon: '📊',
    title: 'Módulo 2 — Sistema de Evidencia Clínica y Método 360°',
    desc: 'Dashboard clínico mensual · Cómo comunicar el progreso a los pacientes · Protocolo de la sesión perfecta · Registro post-sesión en 5 minutos · Las 7 métricas clínicas que toda psicóloga de élite registra · La sesión de resultados trimestral'
  }, {
    icon: '🔬',
    title: 'Módulo 3 — Protocolos de Casos Complejos',
    desc: 'Ansiedad + Depresión: el doble cuadro más frecuente · Trauma y vínculos disfuncionales · Casos sin diagnóstico claro · Fracaso terapéutico sin causa evidente · Cómo justificar honorarios diferenciales · Cómo construir tu equipo interdisciplinario de élite'
  }, {
    icon: '💰',
    title: 'Módulo 4 — Ingeniería de Precios y Modelo High-Ticket',
    desc: 'El modelo de 3 niveles de servicio · Cómo estructurar tu propuesta premium · Cómo comunicar tu honorario sin disculpas · Paquetes y descuentos estratégicos · Gestión de objeciones al precio · Los 7 detalles que incrementan el valor percibido · La lista de espera como estrategia'
  }, {
    icon: '📱',
    title: 'Módulo 5 — Autoridad Digital y Marca Personal',
    desc: 'El perfil de Instagram de autoridad clínica · Los 10 tipos de contenido que generan más confianza · Plan de contenido de 30 días · Cómo convertir seguidores en consultas reales · La autoridad que se construye fuera de las redes'
  }, {
    icon: '💡',
    title: 'Módulo 6 — Diversificación de Ingresos',
    desc: 'Talleres grupales para pacientes: el mayor ROI de tiempo · Supervisión clínica a colegas · Consultoría a instituciones · Plan de diversificación de ingresos en 90 días'
  }, {
    icon: '🗓️',
    title: 'Módulo 7 — Plan de 90 Días para Duplicar tu Hora Clínica',
    desc: 'Mes 1: Fundamentos · Mes 2: Implementación · Mes 3: Consolidación · Métricas del plan semana a semana · Checklist del Día 90'
  }];
  return <section className="py-8 px-4 bg-dark-card/30" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <div className="text-center mb-6" data-id="element-31">
          <h2 className="text-2xl md:text-3xl font-black mb-2 text-slate-900" data-id="element-32">
            🚀 ¿QUÉ AGREGA CLÍNICA FLOW™?
          </h2>
          <p className="text-slate-600 text-sm max-w-xl mx-auto" data-id="element-33">
            Para la psicóloga que ya tiene las herramientas clínicas y ahora
            quiere construir una práctica que pague lo que merece.
          </p>
        </div>

        <div className="space-y-2 mb-6" data-id="element-34">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-dark-card border border-dark-border rounded-xl p-3 grid grid-cols-3 gap-2 items-center" data-id="element-35">
              <div className="font-bold text-slate-900 text-sm" data-id="element-36">{row.sit}</div>
              <div className="flex items-center space-x-1.5 text-xs" data-id="element-37">
                <X className="w-3.5 h-3.5 text-red-500 flex-shrink-0" data-id="element-38" />
                <span className="text-slate-500" data-id="element-39">{row.sin}</span>
              </div>
              <div className="flex items-center space-x-1.5 text-xs" data-id="element-40">
                <Check className="w-3.5 h-3.5 text-brand flex-shrink-0" data-id="element-41" />
                <span className="text-slate-900 font-medium" data-id="element-42">{row.con}</span>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-4" data-id="element-43">
          <h3 className="text-lg font-black text-slate-900" data-id="element-44">
            ✅ INCLUYE 7 MÓDULOS:
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-45">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-dark border border-dark-border p-3 rounded-xl flex items-start space-x-2" data-id="element-46">
              <span className="text-lg" data-id="element-47">{mod.icon}</span>
              <div data-id="element-48">
                <h4 className="font-bold text-brand text-xs" data-id="element-49">{mod.title}</h4>
                <p className="text-slate-600 text-xs" data-id="element-50">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 text-center" data-id="element-51">
          <p className="text-slate-600 italic text-sm max-w-xl mx-auto leading-relaxed" data-id="element-52">
            "Si los 6 Tomos te dieron las herramientas para ser una psicóloga
            extraordinaria clínicamente, Clínica Flow™ te da las herramientas
            para ser una psicóloga extraordinaria económicamente."
          </p>
        </motion.div>
      </div>
    </section>;
}